import Image from 'next/image';
import { oneLine } from 'common-tags';

import { Container, NextLink } from '@/atoms';

import { removeBaseURL } from '@/lib/utils';
import Button from '../button';
import styles from './CardStep.module.css';

import type { FunctionComponent } from 'react';
import type { TypeCardStepProps } from './types';

/**
 * CardStep
 */
export const CardStep: FunctionComponent<TypeCardStepProps> = ({
  className = '',
  pretitle,
  title,
  subtitle,
  description,
  button,
  image,
  size = 'large',
  stroke,
}: TypeCardStepProps) => (
  <Container
    justify="justify-start"
    align="items-center"
    textAlign="text-center"
    className={oneLine`
      ${styles['c-card-step']}
      ${styles[`c-card-step--${size}`]}
      ${stroke ? styles['c-card-step--stroke'] : ''}
      ${size === 'large' ? 'gap-8' : ''} 
      ${size === 'small' ? 'gap-6' : ''}
      p-6
      ${className}
    `}
  >
    {image && (
      <div className="max-w-[140px]">
        <Image
          src={image.sourceUrl}
          width={image.mediaDetails?.width}
          height={image.mediaDetails?.height}
          alt={image.altText}
        />
      </div>
    )}

    <div
      className={oneLine`
        flex flex-col items-center gap-4
        ${size === 'large' ? 'w-[266px]' : ''} 
        ${size === 'small' ? 'w-[242px]' : ''}
      `}
    >
      <div className="flex flex-col gap-1">
        {pretitle && (
          <span className={styles['c-card-step__pretitle']}>{pretitle}</span>
        )}

        {title && <span className={styles['c-card-step__title']}>{title}</span>}

        {subtitle && (
          <span className={styles['c-card-step__subtitle']}>{subtitle}</span>
        )}
      </div>

      {description && (
        <div
          className={styles['c-card-step__description']}
          dangerouslySetInnerHTML={{ __html: description }}
        />
      )}

      {button && button.link && (
        <NextLink href={removeBaseURL(button?.link?.url ?? '')} passHref>
          <Button
            label={button.label}
            negative={button.negativo}
            as="a"
            style={button.style}
          />
        </NextLink>
      )}
    </div>
  </Container>
);
